"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyles = void 0;

var _styledComponents = require("styled-components");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _fonts = require("./fonts");

var GlobalStyles = (0, _styledComponents.createGlobalStyle)((0, _css.default)({
  '*, *:before, *:after': {
    boxSizing: 'inherit'
  },
  html: {
    backgroundColor: 'background.pureWhite',
    boxSizing: 'border-box',
    height: '100%'
  },
  body: {
    margin: 0,
    fontSize: 2,
    fontFamily: 'normal',
    color: '#161616',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    textRendering: 'optimizeLegibility',
    WebkitTapHighlightColor: 'brandLight',
    WebkitOverflowSrolling: 'touch'
  },
  'input, button, select, textarea': {
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'normal',
    color: 'inherit',
    outline: 'none'
  },
  'sub, pub': {
    fontSize: '0.8em'
  },
  sub: {
    bottom: '-0.2em'
  },
  sup: {
    top: '0.2em'
  },
  b: {
    fontWeight: '500'
  },
  svg: {
    verticalAlign: 'middle',
    display: 'block'
  },
  ul: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  }
}), {
  html: {
    lineHeight: 1
  }
}, _fonts.fontStyles);
exports.GlobalStyles = GlobalStyles;